/**
 * Slice LEVI-NAV-01 · Frontend fail-closed destination whitelist.
 *
 * The backend registry at `backend/levi_nav_registry.py` is the single
 * authoritative source. This module is a MINIMAL mirror the frontend
 * uses to reject unknown destination_keys. An automated parity test
 * in the backend focused suite reads this file and asserts every
 * backend key is present here — a mismatch fails a test rather than
 * becoming a production navigation error (§refinement 1).
 *
 * DO NOT add local route strings anywhere else. React Router routes
 * live in App.js. This file only maps destination_key -> route
 * template + required param names so that the client can reject
 * anything not in this list.
 */

// Keep this list ALPHABETICALLY SORTED so parity checks are trivial.
export const LEVI_NAV_DESTINATIONS = Object.freeze({
  closeout_detail:       { route: "/app/closeout/:id",                    params: ["id"] },
  closeout_list:         { route: "/app/closeout",                        params: [] },
  contract_detail:       { route: "/app/contracts/:cid",                  params: ["cid"] },
  contracts_list:        { route: "/app/contracts",                       params: [] },
  crew_packet:           { route: "/app/projects/:pid/crew-packet",       params: ["pid"] },
  customer_detail:       { route: "/app/customers/:cid",                  params: ["cid"] },
  customer_new_form:     { route: "/app/customers/new",                   params: [] },
  customers_list:        { route: "/app/customers",                       params: [] },
  dashboard:             { route: "/app",                                 params: [] },
  estimate_detail:       { route: "/app/estimates/:eid",                  params: ["eid"] },
  estimates_list:        { route: "/app/estimates",                       params: [] },
  invoice_detail:        { route: "/app/invoices/:iid",                   params: ["iid"] },
  invoices_list:         { route: "/app/invoices",                        params: [] },
  material_takeoff:      { route: "/app/projects/:pid/material-takeoff",  params: ["pid"] },
  profitability:         { route: "/app/projects/:pid/profitability",     params: ["pid"] },
  project_media:         { route: "/app/projects/:pid",                   params: ["pid"] },
  project_workspace:     { route: "/app/projects/:pid",                   params: ["pid"] },
  projects_list:         { route: "/app/projects",                        params: [] },
  proposal_detail:       { route: "/app/proposals/:pid",                  params: ["pid"] },
  proposals_list:        { route: "/app/proposals",                       params: [] },
  schedule:              { route: "/app/schedule",                        params: [] },
  walkthrough_review:    { route: "/app/projects/:pid",                   params: ["pid"] },
  work_order_detail:     { route: "/app/work-orders/:wid",                params: ["wid"] },
  work_orders_list:      { route: "/app/work-orders",                     params: [] },
});

export const isSupportedDestination = (key) =>
  Object.prototype.hasOwnProperty.call(LEVI_NAV_DESTINATIONS, key);

export const resolveDestinationRoute = (key, params) => {
  const entry = LEVI_NAV_DESTINATIONS[key];
  if (!entry) return null;
  let route = entry.route;
  for (const p of entry.params) {
    const v = params && params[p];
    if (!v || typeof v !== "string") return null;
    route = route.replace(":" + p, v);
  }
  return route;
};
